import React from 'react';
import styled from 'styled-components';

// Caremate microservices architecture: client → gateway → four autonomous services
// (each with its own DB) → RabbitMQ → notifications, inside a Docker boundary.
const Wrap = styled.div`
  margin-top: 16px;
  padding: 22px 18px 16px;
  background: var(--light-navy);
  border: 1px solid var(--lightest-navy);
  border-radius: var(--border-radius);

  .tier {
    display: flex;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
  }
  .box {
    padding: 10px 16px;
    text-align: center;
    background: var(--navy);
    border: 1px solid var(--lightest-navy);
    border-radius: var(--border-radius);
  }
  .box .n {
    color: var(--lightest-slate);
    font-size: var(--fz-sm);
    font-weight: 600;
  }
  .box .s {
    margin-top: 3px;
    color: var(--slate);
    font-size: var(--fz-xxs);
  }
  .box.accent {
    background: var(--green-tint);
    border-color: var(--green);
  }
  .box.accent .n {
    color: var(--green);
  }

  .down {
    margin: 8px 0;
    text-align: center;
    color: var(--dark-slate);
    font-size: var(--fz-lg);
    line-height: 1;
    small {
      display: block;
      margin-bottom: 3px;
      color: var(--slate);
      font-size: var(--fz-xxs);
      font-style: italic;
    }
  }

  .dock {
    position: relative;
    margin-top: 12px;
    padding: 24px 14px 14px;
    border: 1px dashed var(--dark-slate);
    border-radius: var(--border-radius);
  }
  .dock-tag {
    position: absolute;
    top: -9px;
    left: 14px;
    padding: 0 8px;
    background: var(--light-navy);
    color: var(--slate);
    font-family: var(--font-mono);
    font-size: var(--fz-xxs);
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }
  .aside {
    position: absolute;
    top: 18px;
    right: 14px;
    max-width: 118px;
    text-align: right;
    color: var(--slate);
    font-size: var(--fz-xxs);
    line-height: 1.35;
    b {
      color: var(--light-slate);
    }
  }

  .svcs {
    display: flex;
    gap: 10px;
  }
  .svc {
    flex: 1;
    min-width: 0;
    .box {
      padding: 9px 6px;
    }
    .db {
      margin-top: 6px;
      text-align: center;
      color: var(--slate);
      font-family: var(--font-mono);
      font-size: var(--fz-xxs);
    }
  }

  @media (max-width: 640px) {
    .aside {
      position: static;
      max-width: none;
      margin-bottom: 12px;
      text-align: left;
    }
    .svcs {
      flex-wrap: wrap;
    }
    .svc {
      flex-basis: calc(50% - 5px);
    }
  }
`;

export const CaremateArchitecture = () => (
  <Wrap>
    <div className="tier">
      <div className="box">
        <div className="n">Client</div>
        <div className="s">Next.js · TypeScript · Tailwind</div>
      </div>
    </div>

    <div className="down">↓</div>

    <div className="dock">
      <span className="dock-tag">Docker</span>
      <div className="aside">
        Service registry
        <br />
        <b>Eureka</b>
        <br />
        (enregistrement automatique)
      </div>

      <div className="tier">
        <div className="box accent">
          <div className="n">API Gateway</div>
          <div className="s">routage · authentification par token</div>
        </div>
      </div>

      <div className="down">↓</div>

      <div className="svcs">
        <div className="svc">
          <div className="box">
            <div className="n">ms-users</div>
            <div className="s">auth &amp; profils</div>
          </div>
          <div className="db">MongoDB</div>
        </div>
        <div className="svc">
          <div className="box">
            <div className="n">ms-search</div>
            <div className="s">recherche &amp; filtres</div>
          </div>
          <div className="db">MongoDB</div>
        </div>
        <div className="svc">
          <div className="box">
            <div className="n">ms-communication</div>
            <div className="s">messagerie (Socket.IO)</div>
          </div>
          <div className="db">MongoDB</div>
        </div>
        <div className="svc">
          <div className="box">
            <div className="n">ms-booking</div>
            <div className="s">réservations</div>
          </div>
          <div className="db">MongoDB</div>
        </div>
      </div>

      <div className="down">
        <small>publie un événement (réservation confirmée…)</small>↓
      </div>

      <div className="tier">
        <div className="box">
          <div className="n">RabbitMQ</div>
          <div className="s">bus d&apos;événements</div>
        </div>
      </div>

      <div className="down">
        <small>s&apos;abonne</small>↓
      </div>

      <div className="tier">
        <div className="box">
          <div className="n">ms-notifications</div>
          <div className="s">découplé des autres services</div>
        </div>
      </div>
    </div>
  </Wrap>
);
